const Report = () =>
  import(
    /* webpackChunkName: "financial-tariff-trash" */ '@/pages/financial/tariff/furniture/furniture-tariff/index.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "financial-tariff-furniture" */ '@/pages/financial/tariff/furniture/furniture-tariff/create.vue'
  )
const Edit = () =>
  import(
    /* webpackChunkName: "financial-tariff-furniture" */ '@/pages/financial/tariff/furniture/furniture-tariff/edit.vue'
  )

export default {
  name: 'FinancialFurnitureFurnitureTariff',
  path: 'furniture-tariff',
  meta: {
    label: 'furnitureTariff',
    auth: 'furniture'
  },
  component: {
    name: 'FurnitureTariff',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FinancialTariffFurnitureReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'FinancialCreateTariffFurniture',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'FinancialEditTariffFurniture',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
